
import React, { Component } from "react";
import Lottie from "lottie-react";
import animationJson from "./confetti.json";

export interface ConfettiAnimationProps
{
    onComplete: () => void;
}

interface ConfettiAnimationState 
{
}

export class ConfettiAnimation extends Component<ConfettiAnimationProps, ConfettiAnimationState>
{
    constructor(props: ConfettiAnimationProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <Lottie animationData={animationJson} loop={false} onComplete={this.props.onComplete.bind(this)} />
        );
    }
}